import { type FC } from 'react';
import cx from 'classnames';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import type { UsageReportWeeklyTrend } from 'src/graphql/reports/queryUsageReportDashboard';

import { ChartTooltip } from '../ChartTooltip';

import { useStyles } from './useStyles';

const COLORS = {
  superUsers: '#3D7FFE',
  activeUsers: '#41C493',
  inactiveUsers: '#DA5667',
};

interface UserActivityChartProps {
  className?: string;
  data: UsageReportWeeklyTrend[];
}

export const UserActivityChart: FC<UserActivityChartProps> = ({ className, data }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.title}>User Activity Trends</div>
      <ResponsiveContainer
        width="100%"
        height="90%"
      >
        <LineChart
          data={data}
          margin={{ top: 10, right: 15, left: 0, bottom: 5 }}
        >
          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
          />
          <XAxis
            dataKey="week"
            tickLine={false}
            tickFormatter={(v) => {
              if (!v) return '';
              const d = new Date(v);
              return `${d.getMonth() + 1}/${d.getDate()}`;
            }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickCount={5}
            width={40}
          />
          <Tooltip content={<ChartTooltip />} />
          <Legend
            align="left"
            verticalAlign="bottom"
            iconType="line"
          />
          <Line
            name="Super Users"
            type="monotone"
            dataKey="superUsersCount"
            stroke={COLORS.superUsers}
            strokeWidth={2}
            dot={{ r: 3, fill: 'white', strokeWidth: 2 }}
            isAnimationActive={false}
          />
          <Line
            name="Active Users"
            type="monotone"
            dataKey="activeUsersCount"
            stroke={COLORS.activeUsers}
            strokeWidth={2}
            dot={{ r: 3, fill: 'white', strokeWidth: 2 }}
            isAnimationActive={false}
          />
          <Line
            name="Inactive Users"
            type="monotone"
            dataKey="inactiveUsersCount"
            stroke={COLORS.inactiveUsers}
            strokeWidth={2}
            dot={{ r: 3, fill: 'white', strokeWidth: 2 }}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
